import L from 'leaflet'
import { memo, useMemo } from 'react'
import { GeoJSON } from 'react-leaflet'

import { Map } from '@/components/map'
import { CogTileLayerProxy } from '@/components/map/cog-tile-layer/proxy'
import { UseGetInfestationFromDiagnosisResponse } from '@/hooks/queries/use-get-infestation-from-diagnosis'
import { Label } from '@/pages/diagnosis-view/components/geo-json-map/label'

interface WeedMapProps
  extends Pick<UseGetInfestationFromDiagnosisResponse, 'perimeter'> {
  mapLabel: string
  children: React.ReactNode
  cogUrl?: string
}

const WeedMapComponent = ({
  perimeter,
  mapLabel,
  children,
  cogUrl,
}: WeedMapProps) => {
  const { perimeterBounds, maxBounds } = useMemo(() => {
    const bounds = L.geoJSON(perimeter).getBounds()

    const maxBounds = L.latLngBounds(
      bounds.getSouthWest(),
      bounds.getNorthEast(),
    ).pad(0.6)

    return { perimeterBounds: bounds, maxBounds }
  }, [perimeter])

  return (
    <Map
      bounds={perimeterBounds}
      maxBounds={maxBounds}
      preferCanvas
      whenCreated={(map) => map.setMinZoom(map.getBoundsZoom(maxBounds))}
      zoomSnap={1}
      markerZoomAnimation={false}
      disabledControls={{ attributionControl: true }}
      positionControls={{ attributionControl: 'bottomleft' }}
    >
      <Label title={mapLabel} />

      {cogUrl && <CogTileLayerProxy url={cogUrl} />}

      <GeoJSON
        data={perimeter}
        style={{
          color: '#716FD0',
          weight: 2,
          fillRule: 'nonzero',
          fill: false,
        }}
      />

      {children}
    </Map>
  )
}

export const WeedMap = memo(WeedMapComponent)
